import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {BadgeDetailPage} from './components/badge-detail-page/badge-detail-page';
import {BadgeImage} from './components/badge-image/badge-image.component';
import {BadgePage} from './components/badge-page/badge-page';
import {ColorFilter} from './components/color-filter/color-filter.component';
import {BadgeRepository} from './repositories/badge.repository';
import {BadgeService} from './services/badge.service';
import { LeadaComponentsModule } from 'shared/components';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild([
      { path: '', component: BadgePage },
      { path: 'detail', component: BadgeDetailPage },
    ]),
    TranslateModule,
    LeadaComponentsModule,
  ],
  providers: [
    BadgeRepository,
    BadgeService,
  ],
  declarations: [
    BadgePage,
    BadgeDetailPage,
    ColorFilter,
    BadgeImage,
  ],
  // entryComponents: [
  //   BadgePage,
  //   BadgeDetailPage,
  // ],
})
export class BadgeModule { }
